import { render, staticRenderFns } from "./GoBackHeaderPercentage.vue?vue&type=template&id=918527d8&scoped=true"
import script from "./GoBackHeaderPercentage.vue?vue&type=script&lang=ts"
export * from "./GoBackHeaderPercentage.vue?vue&type=script&lang=ts"
import style0 from "./GoBackHeaderPercentage.vue?vue&type=style&index=0&id=918527d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918527d8",
  null
  
)

export default component.exports